import { FooterMenu } from "components"
import { useApi, useHandleAuth, useToggle } from "utils"
import { AdjustmentInventoryType, AdjustmentInventoryValidation, finalData, validateAdjusmentDetail } from "./utils"
import { AttachmentModal, FormDirectAdjusment, JournalAdjusment, PrintAdjustmentInventory } from "./components"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import moment from "moment"
import { LocationProvider } from "contexts"
import toast from "react-hot-toast"
import { LinkAccountProvider } from "./contexts"

export default function AdjustmentInventory(): JSX.Element {
  const { isActive, toggle } = useToggle(false)
  const api = useApi()

  const { userTokenData } = useHandleAuth()
  const auth = userTokenData()

  const defaultValues: AdjustmentInventoryType = {
    employee_id: auth?.user_id.toString() ?? "",
    location_id: "",
    memo: "",
    transaction_date: moment().format("YYYY-MM-DD"),
    adjusmentDetail: [],
    trx_code: "",
    attach_file: []
  }

  const method = useForm<AdjustmentInventoryType>({
    resolver: yupResolver(AdjustmentInventoryValidation),
    defaultValues: defaultValues
  })

  const onSubmit = (data: AdjustmentInventoryType) => {
    const customValidations = validateAdjusmentDetail(data)

    if (Object.keys(customValidations).length > 0) {
      for (const path in customValidations) {
        method.setError(path as any, {
          type: 'manual',
          message: customValidations[path]
        })
      }
      return
    }
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post("/invadjustment/add_direct_adjustment", finalData(data)),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      ).then(() => {
        method.reset(defaultValues)
      }).catch(() => { }).finally(resolve)
    })
  }

  return (
    <section className="container my-5 flex flex-col gap-5">
      <FormProvider {...method}>

        <LocationProvider>
            <LinkAccountProvider>
              <FormDirectAdjusment title="ADJUSTMENT INVENTORY" />
            </LinkAccountProvider>
        </LocationProvider>

        <FooterMenu
          delete={{ actiontype: "delete" }}
          print={{ actiontype: "print", onClick: toggle }}
          customElement={{ 
            journal: <JournalAdjusment type="direct" />, 
            attachment: <AttachmentModal /> 
          }}
          save={{
            actiontype: "save",
            type: "button", 
            color: "primary",
            loading: method.formState.isSubmitting ? "true" : undefined,
            onClick: method.handleSubmit(onSubmit)
          }}
        />

        {isActive ? (<PrintAdjustmentInventory isCreate toggle={toggle} />) : null}
      </FormProvider>
    </section>
  )
}


